<template>
  <div class="row products-row category-product category-change-11 filter-page-list category-page js-product-grid">
    <ProductDetail
      v-for="(row) in products" :key="row.id"
      :name="row.name"
      :description="row.description"
      :price="row.price"
      :url="row.url"
      :image="row.image"
     />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { supabase } from './lib/supabaseClient'

import ProductDetail from './components/ProductDetail.vue'

const products = ref([])
let channel = null

// Detect if running in Electron
const isElectron = () => {
  return !!(window && window.process && window.process.type) ||
         !!(window && window.require) ||
         navigator.userAgent.toLowerCase().indexOf('electron') > -1
}

// Configuration based on environment
const IS_ELECTRON = isElectron()
const REAL_TIME_ENABLED = IS_ELECTRON // Real-time pouze pro Electron

console.log(`Environment: ${IS_ELECTRON ? 'Electron' : 'Web'}, Real-time: ${REAL_TIME_ENABLED}`)

async function getProducts() {
  const { data } = await supabase.from('products').select().order('id', { ascending: false }).limit(100)
  products.value = data
}

// Real-time subscription for Electron only
const subscribeToProducts = () => {
  if (!REAL_TIME_ENABLED) {
    console.log('Web version: No real-time, static data only')
    return
  }

  // Ensure we don't create duplicate subscriptions
  if (channel) {
    supabase.removeChannel(channel)
  }

  console.log('Enabling real-time for Electron')
  channel = supabase
    .channel('products-changes')
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'products',
      },
      (payload) => {
        switch (payload.eventType) {
          case 'INSERT': {
            products.value.unshift(payload.new)
            break
          }
          case 'UPDATE': {
            const indexToUpdate = products.value.findIndex(product => product.id === payload.new.id)
            if (indexToUpdate !== -1) {
              products.value[indexToUpdate] = payload.new
            }
            break
          }
          case 'DELETE': {
            products.value = products.value.filter(product => product.id !== payload.old.id)
            break
          }
          default:
            break
        }
      }
    )
    .subscribe()

  return channel
}

onMounted(() => {
  // Vždy načteme data při startu
  getProducts()

  // Real-time pouze pro Electron
  if (IS_ELECTRON) {
    subscribeToProducts()
  }
})

// Cleanup pouze pro Electron
onBeforeUnmount(() => {
  if (channel) {
    supabase.removeChannel(channel)
    channel = null
  }
})
</script>
